import { useMutation } from '@tanstack/react-query';

import type {
  UserModificationsFromToolbar,
  UserModificationsRequest,
} from '../@types/persistUserModifications';
import { makeAPIRequestV2 } from '../utils/api';

import { endpoints } from './endpoints';

interface UseUpdateUserToolbarSettings extends UserModificationsRequest {
  imageId: string;
}

export const useUpdateUserToolbarSettings = () => {
  return useMutation((userModificationsData: UseUpdateUserToolbarSettings) => {
    const { imageId, userModificationsBody } = userModificationsData;

    return makeAPIRequestV2(
      `/v2/${endpoints.images}/${imageId}/${endpoints.userModifications}`,
      { data: userModificationsBody },
      'PATCH',
    );
  });
};

export const generateUserModificationsRequest = (
  imageId: string,
  brightnessValue: number,
  contrastValue: number,
  isOpacityInverted: boolean,
  isHQEnabled: boolean,
  imageManifestId?: number,
): UseUpdateUserToolbarSettings => {
  const modificationsFromImageToolbar: UserModificationsFromToolbar = {
    brightnessValue,
    contrastValue,
    opacityInverted: isOpacityInverted,
    hqEnabled: isHQEnabled,
  };

  return {
    imageId: imageManifestId ? String(imageManifestId) : imageId,
    userModificationsBody: modificationsFromImageToolbar,
  };
};
